import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";
@Component({
    selector: "app-my-snackbar",
    templateUrl: "./my-snackbar.component.html",
    styleUrls: ["./my-snackbar.component.scss"],
    standalone: true,
})
export class MySnackbarComponent implements OnInit {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
  }

  ngOnInit() { }

  get getIcon() {
    switch (this.data.snackType) {
      case "Success":
        return "done";
      case "Error":
        return "close";
      case "Warn":
        return "warning";
      case "Info":
        return "info";
    }
  }
}
